import "../css/marketing.scss"
import Rails from 'rails-ujs'

Rails.start()
